import axios from "axios";

export default {
    actions: {
        async trashShopCart(ctx) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(res => {
                    return axios
                        .delete("/api/shopcart2/trash")
                        .then(res => res);
                })
                .catch(err => err);
            return res;
        },

        async fetchAllShopCart(ctx, token) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(res => {
                    return axios.post("/api/shopcart/show2").then(res => res);
                })
                .catch(err => false);
            return res;
        }
    },

    mutations: {
        uptadeshopcardProductCounts(state) {
            let count = 0;
            const productKeys = Object.keys(state.products);

            productKeys.forEach(productKey => {
                const sellerKeys = Object.keys(
                    state.products[productKey].packages
                );

                sellerKeys.forEach(sellerKey => {
                    count += Number(
                        state.products[productKey].packages[sellerKey].count
                    );
                });
            });
            state.productCounts = productKeys.length;
            state.allProductCounts = count;
        },

        updateShopcartProductCountsManually(state, count) {
            state.productCounts = count;
        },

        addProductToShopCard(state, product) {
            product.packages = {};
            state.products[product.id] = product;
            this.commit("uptadeshopcardProductCounts");
        },

        addPackageToShopCard(state, { product, pack }) {
            state.products[product.id].packages[pack.id] = pack;
            this.commit("uptadeshopcardProductCounts");
        },

        updateProductCountOnShopCard(state, { productId, countProduct }) {
            state.products[productId].count = countProduct;
            this.commit("uptadeshopcardProductCounts");
        },

        updateProductAmountOnShopCard(state, { productId, amountProduct }) {
            state.products[productId].amount = amountProduct;
        },

        updateProductCountOnShopCardPackage(
            state,
            { productId, packId, countPackage }
        ) {
            state.products[productId].packages[packId].count = countPackage;
            this.commit("uptadeshopcardProductCounts");
        },

        updateShopCartId(state, number) {
            state.shopCartId = number;
        },

        updateShopCartAmount(state, number) {
            state.shopCartAmount = Number(number);
        },

        updateShopCartWeight(state, weight) {
            state.shopCartWeight = Number(weight);
        },

        removeProductFromShopCard(state, productId) {
            delete state.products[productId];
            this.commit("uptadeshopcardProductCounts");
        },

        removeProductPackageFromShopCard(state, { productId, packId }) {
            delete state.products[productId].packages[packId];
            this.commit("uptadeshopcardProductCounts");
        },

        resetAllShopCartData(state) {
            state.productCounts = 0;
            state.allProductCounts = 0;
            state.shopCartWeight = 0;
            state.shopCartAmount = 0;
            state.shopCartId = 0;
            state.products = {};
            state.oldProducts = {};
        },

        updateOldShopCartProduct(state, products) {
            state.oldProducts = products;
        },

        resetOldShopCartProducts(state) {
            state.oldProducts = {};
        }
    },

    state() {
        return {
            productCounts: 0,
            allProductCounts: 0,
            shopCartAmount: 0,
            shopCartWeight: 0,
            shopCartId: null,
            products: {},
            oldProducts: {}
        };
    },

    getters: {
        shopcardProductCounts(state) {
            return state.productCounts;
        },

        shopcardProduct: state => productId => {
            return state.products[productId];
        },

        shopcardPackage: state => (productId, packId) => {
            return state.products[productId]?.packages[packId];
        },

        shopcardProductCount: state => productId => {
            return state.products[productId]?.count;
        },

        shopCardPackageCount: state => (productId, packageId) => {
            return state.products[productId]?.packages[packageId]?.count;
        },

        productShopCartCommonAmount: state => productId => {
            return state.products[productId]?.amount;
        },

        getAllShopCart(state) {
            return state.products;
        },

        getShopCartProductCount(state) {
            return state.productCounts;
        },

        getShopCartAllProductsCount(state) {
            return state.allProductCounts;
        },

        getShopCartId(state) {
            return state.shopCartId;
        },

        getShopCartAmount(state) {
            return state.shopCartAmount;
        },

        getShopCartWeight(state) {
            return state.shopCartWeight;
        },

        getAllOldShopCart(state) {
            return state.oldProducts;
        }
    }
};
